module.exports = __webpack_public_path__ + "img/trash.1127b8fc.svg";